import { createCoachStore } from "./sessionStore";
import { createBrowserAudioAdapter } from "./audioAdapters";

// An exclusive origin-wide Web Lock also prevents competing coaches in another tab.
// Unsupported hosts fail closed; the native host will supply its own lease implementation.
export function acquireBrowserCoachLease(locks = globalThis.navigator?.locks) {
  if (!locks?.request) return Promise.resolve(null);
  return new Promise(resolve => {
    locks.request("performance-care-training-coach", { ifAvailable: true }, lock => {
      if (!lock) { resolve(null); return undefined; }
      return new Promise(release => resolve(release));
    }).catch(() => resolve(null));
  });
}

let store;
let sequence = 0;
export function browserCoachStore() {
  if (!store) store = createCoachStore({ clock: { now: () => performance.now() }, createAudio: () => createBrowserAudioAdapter(),
    acquireLease: () => acquireBrowserCoachLease(), idFactory: () => globalThis.crypto?.randomUUID?.() || `coach-${Date.now().toString(36)}-${++sequence}` });
  return store;
}
